import { useMemo } from 'react';
import { Box, Backdrop, Typography } from '@material-ui/core';
import Layout from './Layout';
import String from './String';
import { useLanguage } from '../contexts/language';
import { useSession } from '../contexts/session';
import { useTheme } from '../contexts/theme';

export function CreditsOverlay({ open }) {
  const { content } = useLanguage();
  const { selectedExperience } = useSession();
  const { styles } = useTheme();
  const creditsJson = useMemo(() => selectedExperience?.creditsBlocks ?? [], [selectedExperience]);
  return (
    <Backdrop
      style={{ position: 'absolute', zIndex: 5 }}
      open={open}
      aria-hidden={!open}
      role="dialog"
      aria-label={content('credits')}
    >
      <Layout justify="center" bgColor={styles.palette.background.default}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="stretch"
          width="100%"
          maxWidth={720}
          maxHeight="100vh"
          overflow="auto"
          px={3}
          py={4}
        >
          {creditsJson.length === 0 ? (
            <Typography align="center" color="textSecondary">
              <String s="noCredits" default="No credits yet. Add one below." />
            </Typography>
          ) : (
            creditsJson.map((block) => {
              if (!block) return null;

              switch (block.type) {
                case 'text': {
                  const text = typeof block.text === 'string' ? block.text : '';
                  if (!text.trim()) return null;
                  return (
                    <Box key={block.id} component="section" aria-label="Credits text" mb={3}>
                      <Typography variant="body1" align="center">
                        {text}
                      </Typography>
                    </Box>
                  );
                }

                case 'images': {
                  const images = Array.isArray(block.images) ? block.images : [];
                  if (images.length === 0) return null;
                  return (
                    <Box
                      key={block.id}
                      component="section"
                      aria-label="Credits images"
                      display="flex"
                      flexDirection="row"
                      flexWrap="wrap"
                      justifyContent="center"
                      alignItems="center"
                      style={{ gap: 16, marginBottom: 24 }}
                    >
                      {images.map((image) => (
                        <img
                          key={`${block.id}_${image.id}`}
                          src={image.url}
                          alt={image.alt || 'image'}
                          loading="lazy"
                          style={{
                            display: 'block',
                            height: 80,
                            width: 'auto',
                            maxWidth: '100%',
                            objectFit: 'contain',
                            filter: styles?.palette?.type === 'dark' ? 'brightness(0.95)' : 'none',
                          }}
                        />
                      ))}
                    </Box>
                  );
                }
                default:
                  return null;
              }
            })
          )}
        </Box>
      </Layout>
    </Backdrop>
  );
}
